'use client';

import { useEffect, useRef } from 'react';
import { sendGTMEvent } from '@next/third-parties/google';
import { AD_VIEW_SOURCE_QUERY_PARAM, decodeAdViewSource, AdViewSourceEvent } from '@/utils/adViewSource';

type Props = {
  fallbackSource?: AdViewSourceEvent | null;
};

export function AdViewSourceGTMSend({ fallbackSource }: Props) {
  const hasSent = useRef(false);

  useEffect(() => {
    if (hasSent.current) return;
    hasSent.current = true;

    let source = fallbackSource ?? null;
    try {
      const stored = sessionStorage.getItem(AD_VIEW_SOURCE_QUERY_PARAM);
      if (stored) {
        sessionStorage.removeItem(AD_VIEW_SOURCE_QUERY_PARAM);
        source = decodeAdViewSource(stored) ?? source;
      }
    } catch {}

    sendGTMEvent({ event: 'ad_view', ...(source ? { source } : {}) });
  }, [fallbackSource]);

  return null;
}
